import ApplicationAccess from "./application-access"
import DefaultPortfolio from "./default-portfolio"
import DeleteConfirmation from "./delete-confirmation"
import Users from "./users"

export default {
  ApplicationAccess,
  DefaultPortfolio,
  DeleteConfirmation,
  Users
}